export default "__VITE_ASSET__BXRDt8Vh__"